module.exports = __webpack_public_path__ + "static/img/icon-FAQ.3bf21002.svg";